import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import lionsLogo from "../../../assets/images/headercreationlogo.png";
import Menu from "./../../../assets/HomeAssets/assets/images/menu.svg";
import Close from "./../../../assets/HomeAssets/assets/images/close.svg";
import back from "./../../../assets/images/back.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPromotion } from "../../../store/api/cart";
import NavItemWithSubmenu from "./components/GetTheAppHeaderWeb";
import { FaAndroid, FaAppStore } from "react-icons/fa";
export default function SataliteHeader() {
  const navigate = useNavigate();
  // const [showSearchInput, setShowSearchInput] = useState(false);

  // menu useState
  const [menuVisible, setMenuVisible] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [showMblSubmenu, setMblSubmenu] = useState(false);
  const { isMainSite} = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  // handleSearchButtonClick funstion
  // const handleSearchButtonClick = () => {
  //   setShowSearchInput(!showSearchInput);
  // };
  const handleShowMblMenu = () => {
    setMblSubmenu(true);
  };

  const handleCloseMblMenu = () => {
    setMblSubmenu(false);
  };
  useEffect(() => {
    if (isMainSite === true) {
     dispatch(
      getPromotion({
        onSuccess: (res) => {
          // console.log("promotion ===>", res.data.promotion);
        },
      })
    );
    }
  
  }, [isMainSite]);
  const handleOpenClick = () => {
    setMenuVisible(true);
  };

  const handleCloseClick = () => {
    setMenuVisible(false);
    setMblSubmenu(false);
  };

  return (
    <>
      <div className="theme-container ">
        <div className="satalite-header">
          <div className="satalite-header-menu">
            <ul>
              <li className="nav-item"  onMouseEnter={() => setShowSubmenu(false)}>
                <Link to="/about-us" className="nav-link">
                  About{" "}
                </Link>
              </li>
              <li className="nav-item"  onMouseEnter={() => setShowSubmenu(false)}>
                <Link
                  to="/contact"
                  className="fw-600 text-white  cus_mr_20 nav-link get_app_header_text"
                >
                  Contact{" "}
                </Link>
              </li>
              <NavItemWithSubmenu
                showSubmenu={showSubmenu}
                setShowSubmenu={setShowSubmenu}
              />
            </ul>
          </div>
          <div onClick={() => navigate("/")} className="satalite-header-logo">
            <img src={lionsLogo} alt="logo" />
          </div>
          <div className="wrap-header-btn">
            <button
              onClick={() => navigate("/login")}
              className="themebtn-green header-btn-login"
            >
              {" "}
              Login
            </button>
            {isMainSite === true  && 
            <button
              onClick={() => navigate("/signup")}
              className="themebtn-green"
            >
              New account
            </button>
            }
          </div>
        </div>
      </div>
      {/* mobile_menu_wrap */}
      <div className="mobile_menu_wrap">
        {menuVisible && !showMblSubmenu && (
          <div
            className="menu_list mobile-menu"
            style={{ display: menuVisible ? "block" : "none" }}
          >
            <ul className="footer-list2">
              <li>
                <Link to="/login">Sign In</Link>
              </li>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/contact"> Contact</Link>
              </li>
              <li
                onClick={handleShowMblMenu}
                className="mbl-header-get_app pointer"
              >
                <span>Get the App</span>
              </li>
            </ul>
          </div>
        )}
        {menuVisible && showMblSubmenu && (
          <div
            className="menu_list mobile-menu"
            style={{ display: showMblSubmenu ? "block" : "none" }}
          >
            {/* <h1 className="red_mang_coins">Get the App</h1> */}
            <button
              type="button"
              onClick={handleCloseMblMenu}
              className="back_redeem"
            >
              <img src={back} alt="back" />
              <p className="redeem_back_p">Back</p>
            </button>
            <ul className="footer-list2">
            <li>
                <Link 
                target="_blank"
                rel="noopener noreferrer"
                to="https://www.lionsdengames.net/download-ios">IOS</Link>
              </li>
              <li>
                <Link 
                  target="_blank"
                  rel="noopener noreferrer"
                  to="https://www.lionsdengames.net/download-android">Android</Link>
              </li>
             
            </ul>
          </div>
        )}

        <button
          className="BtnOpen"
          onClick={handleOpenClick}
          style={{ display: menuVisible ? "none" : "inline" }}
        >
          <img src={Menu} alt="open" />
          <span>Menu</span>
        </button>
        <button
          className="BtnClose"
          onClick={handleCloseClick}
          style={{ display: menuVisible ? "inline-block" : "none" }}
        >
          <img src={Close} alt="close" />
        </button>
      </div>
    </>
  );
}
